const packageJSON = require('../package.json');

const { name, applicationName } = packageJSON;

module.exports = {
  vault: {
    url: `https://vault.peya.co/v1/secret/web-micro-site-${name}/live`,
    enabled: true,
  },
  apiGateway: {
    url: 'http://client-api-gateway.live.peja.co',
    timeout: 3000,
  },
  countryServices: {
    url: 'http://countries-service.live.peja.co',
    timeout: 2500,
  },
  authServices: {
    url: 'http://auth.live.peja.co',
    timeout: 2500,
  },
  locationService: {
    url: 'http://locations-service.live.peja.co',
    timeout: 5000,
  },
  locationModuleFederation: {
    id: 'webLocation',
    moduleName: 'Location',
    manifest: '/mfe/web-location',
  },
  redis: {
    webApps: {
      host: 'redis-generic-landings-live-wr.live.peja.co',
      port: 6379,
      cookieName: `__Secure-${applicationName}.${name}.sid`,
      sessionName: `${applicationName}.${name}`,
      envName: 'live',
      cookieConfig: {
        httpOnly: true,
        secure: true,
        sameSite: 'lax',
        maxAge: 5400000,
      },
    },
    web: {
      host: {
        latam01: 'redis-web-latam1-wr.live.peja.co',
        latam02: 'redis-web-latam2-wr.live.peja.co',
        latam03: 'redis-web-latam3-wr.live.peja.co',
      },
      port: 6379,
      cookieName: '__Secure-peya.sid',
      sessionName: 'mWeb',
      envName: 'live',
      cookieConfig: {
        httpOnly: true,
        secure: true,
        sameSite: 'lax',
        maxAge: 3600000,
      },
    },
  },
  metrics: {
    enabled: true,
    sampleRate: 1,
    clientName: 'datadog',
    events: [
      'LOADED_EMPTY_FILTER',
      'BT_FILTER_CLICK',
      'ITEM_CLICK',
      'ITEM_TOP_POSITION_CLICK',
      'ITEM_SECOND_RANGE_CLICK',
      'ITEM_THIRD_RANGE_CLICK',
      'ITEM_FOURTH_RANGE_CLICK',
      'VENDOR_SECOND_RANGE_CLICK',
      'VENDOR_THIRD_RANGE_CLICK',
      'VENDOR_FOURTH_RANGE_CLICK',
      'DELIVERY_TIME_FILTER_CLICK',
      'DISTANCE_FILTER_CLICK',
      'RANKING_FILTER_CLICK',
      'TERMS_AND_CONDITIONS_CLICK',
      'BACK_BUTTON_CLICK',
      'VENDOR_TOP_POSITION_CLICK',
      'VENDOR_CLICK',
      'LOADED_EMPTY_STATE',
      'SERVER_ERROR',
      'CLIENT_ERROR',
      'LOADED_EMPTY_ITEM',
      'LOADED_ERROR_ITEM',
    ],
  },
  fwf: {
    httpRequestTimeout: 250,
    flagTimeToLive: 20,
    localFwfUrl: 'http://fwf-client-api.live.peja.co',
  },
  resources: {
    url: 'https://web-commons.pystatic.com',
    js: [
      'https://web-commons.pystatic.com/react/17.0.2/production.min.js',
      'https://web-commons.pystatic.com/react-dom/17.0.2/production.min.js',
    ],
  },
};
